/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import {
  Table,
  Button,
} from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

import { useTranslation } from 'react-i18next';
import { formatLocaleWithTimezone, getLocale } from '../../utils/date';

const SoundSessionAttachmentReverberation = (props) => {
  const {
    attachment,
    timezone,
  } = props;

  const { t, i18n } = useTranslation('translations');
  const locale = getLocale(i18n.language);

  const metadata = React.useMemo(() => {
    const rows = Object.keys(attachment.metadata).map((key) => {
      let value = attachment.metadata[key];
      if (key === 'created') {
        return {
          parameter: 'created',
          value: formatLocaleWithTimezone(value, 'yyyy-MM-dd HH:mm:ss.SSS', locale, timezone),
        };
      }
      if (Array.isArray(value)) {
        value = value.join(',');
      }
      return {
        parameter: key,
        value,
      };
    });
    return rows;
  }, [attachment]);

  const columns = React.useMemo(() => {
    const result = [
      {
        title: t('common.parameter'),
        dataIndex: 'parameter',
        width: '50%',
      },
      {
        title: t('common.value'),
        dataIndex: 'value',
      },
    ];
    return result;
  }, [t]);

  return (
    <>
      <Button
        type="primary"
        block
        download
        target="_blank"
        icon={<DownloadOutlined />}
        size="large"
        href={attachment.url}
      >
        {t('common.download')}
      </Button>
      <Table
        style={{ marginTop: 16 }}
        bordered
        size="small"
        scroll={{ x: true }}
        columns={columns}
        rowKey={(record) => record.parameter}
        dataSource={metadata}
        pagination={false}
      />
    </>
  );
};

const propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  attachment: PropTypes.any.isRequired,
  timezone: PropTypes.string.isRequired,
};

SoundSessionAttachmentReverberation.propTypes = propTypes;

export default SoundSessionAttachmentReverberation;
